import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { formatDate } from '@/utils/formUtils.js'
import { formatDetectionCategory } from 'enumeration/lab-order.js'
import detetionDatas from '../datas/detetion'
import timeutils from 'utils/wt-time-utils'
export default {
  getDetectionListByFilter (ctx, data) {
    return fetch.getDetectionListByFilter(data).then(res => {
      // res.data.forEach(ele => {
      //   ele.category = formatDetectionCategory(ele.category)
      // })
      let result = getTotalNumber(res)
      result.data = detetionDatas.getDetectionListByFilter(result.data)
      return result
    })
  },
  detectionAdd (ctx, data) {
    return fetch.detectionAdd(data).then(res => {
      return res
    })
  },
  getDetectionCorpusList (ctx, data) {
    return fetch.getDetectionCorpusList(data).then(res => {
      res.data.forEach(ele => {
        // ele.type = formatDetectionCategory(ele.type)
        if (!ele.corpusName) {
          ele.corpusName = ele.chineseName
        }
      })
      return getTotalNumber(res)
    })
  },
  deleteDetection (ctx, id) {
    return fetch.deleteDetection(id).then(res => {
      return res
    })
  },
  detectionCorpusAdd (ctx, data) {
    return fetch.detectionCorpusAdd(data).then(res => {
      return res
    })
  },
  getDetectionCorpus (ctx, id) {
    return fetch.getDetectionCorpus(id).then(res => {
      return res
    })
  },
  getDetectionCorpusByid (ctx, id) {
    return fetch.getDetectionCorpusByid(id).then(res => {
      return res
    })
  },
  getDetectionConfig (ctx, id) {
    return fetch.getDetectionConfig(id).then(res => {
      return res
    })
  },
  getDetection (ctx, id) {
    return fetch.getDetection(id).then(res => {
      return res
    })
  },
  getDetectionPackageList (ctx, data) {
    return fetch.getDetectionPackageList(data).then(res => {
      let result = getTotalNumber(res)
      let PackageList = []
      result.data.forEach((item, index) => {
        item.createdTime = timeutils.format(item.createdDate)
        item.index = index
        let single = {
          label: item.name,
          value: item.id
        }
        PackageList.push(single)
      })
      ctx.commit('detectionPackageList', PackageList)
      res.data.forEach(ele => {
        ele.category = formatDetectionCategory(ele.category)
        ele.createdDate = formatDate(ele.createdDate)
      })
      res.data = detetionDatas.getDetectionPackageList(res.data)
      return getTotalNumber(res)
    })
  },
  deleteDetectionPackage (ctx, id) {
    return fetch.deleteDetectionPackage(id).then(res => {
      return res
    })
  },
  importConfigParams (ctx, data) {
    return fetch.importConfigParams(data).then(res => {
      return res
    })
  },
  getDetectionPackage (ctx, id) {
    return fetch.getDetectionPackage(id).then(res => {
      return res
    })
  },
  detectionPackageAdd (ctx, data) {
    return fetch.detectionPackageAdd(data).then(res => {
      return res
    })
  },
  updateDetectionCorpus (ctx, data) {
    return fetch.updateDetectionCorpus(data).then(res => {
      return res
    })
  },
  updateDetection (ctx, data) {
    return fetch.updateDetection(data).then(res => {
      return res
    })
  },
  deleteDetectionCorpus (ctx, id) {
    return fetch.deleteDetectionCorpus(id).then(res => {
      return res
    })
  },
  getCorpusStructureList (ctx, data) {
    return fetch.getCorpusStructureList(data).then(res => {
      return getTotalNumber(res)
    })
  },
  createCorpusStructure (ctx, data) {
    return fetch.createCorpusStructure(data).then(res => {
      return res
    })
  },
  updateCorpusStructure (ctx, data) {
    return fetch.updateCorpusStructure(data).then(res => {
      return res
    })
  },
  deleteCorpusStructure (ctx, id) {
    return fetch.deleteCorpusStructure(id).then(res => {
      return res
    })
  },
  createCorpusHeaderImages (ctx, data) {
    return fetch.createCorpusHeaderImages(data).then(res => {
      return res
    })
  },
  getCorpusStructure (ctx, id) {
    return fetch.getCorpusStructure(id).then(res => {
      return res
    })
  },
  searchDetectionItem (ctx, key) {
    return fetch.searchDetectionItem(key).then(res => {
      return res
    })
  },
  getCorpusStructureListByType (ctx, data) {
    return fetch.getCorpusStructureListByType(data).then(res => {
      return getTotalNumber(res)
    })
  },
  getCustomerSamples (ctx, data) {
    return fetch.getCustomerSamples(data).then(res => {
      res.data.forEach(ele => {
        ele.fullName = ele.lastName + ele.firstName
      })
      return getTotalNumber(res)
    })
  },
  updateDetectionPackage (ctx, data) {
    return fetch.updateDetectionPackage(data).then(res => {
      return res
    })
  },
  getReportData (ctx, data) {
    return fetch.getReportData(data).then(res => {
      return res
    })
  },
  deleteDetectionConfig (ctx, id) {
    return fetch.deleteDetectionConfig(id).then(res => {
      return res
    })
  },
  getDetectionConfigParams (ctx, data) {
    return fetch.getDetectionConfigParams(data).then(res => {
      return res
    })
  },
  getDetectionWithCorpusAndConfig (ctx, id) {
    return fetch.getDetectionWithCorpusAndConfig(id).then(res => {
      return res
    })
  },
  getPackageList (ctx, data) {
    return fetch.getPackageList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = detetionDatas.getPackageList(result.data)
      return result
    })
  },
  getDetectionItemByName (ctx, name) {
    return fetch.getDetectionItemByName(name).then(res => {
      return res.data
    })
  },
  getDetectionCorpusBycorpusAndName (ctx, form) {
    return fetch.getDetectionCorpusBycorpusAndName(form.corpusName, form.chineseName).then(res => {
      return res.data
    })
  },
  getCorpusStructureByquery (ctx, form) {
    return fetch.getCorpusStructureByquery(form.name, form.type).then(res => {
      return res.data
    })
  },
  geConfigSuiteNames (ctx, params) {
    return fetch.geConfigSuiteNames(params).then(res => {
      return res.data
    })
  },
  getItemsByBaseId (ctx, params) {
    return fetch.getItemsByBaseId(params).then(res => {
      return getTotalNumber(res)
    })
  },
  getCorpusSuiteName (ctx, params) {
    return fetch.getCorpusSuiteName(params).then(res => {
      return res.data
    })
  }
}
